export const socialsData = {
    github: 'https://github.com/clevermustafa',
    facebook: 'https://www.facebook.com/mustafa.hawari2',
    linkedIn: 'https://www.linkedin.com/in/clevermustafa',
    instagram: 'https://www.instagram.com/mohammadmustafa377/',
    codepen: 'https://codepen.io/',
    twitter: 'https://twitter.com/clevermustafaa',
    reddit: 'https://www.reddit.com/user/',
    blogger: 'https://www.blogger.com/',
    medium: 'https://medium.com/@',
    stackOverflow: 'https://stackoverflow.com/users/16470571/mustafa-hawari',
    gitlab: 'https://gitlab.com/',
    youtube: 'https://youtube.com/'
}